<!--
 * @Description: 自动配载设置-修改 updateAutoStowage
 * @Author: yuanjiaheng
 * @LastEditors: yuanjiaheng
 * @Date: 2021-07-27 09:24:59
 * @LastEditTime: 2021-08-01 10:52:29
-->
<template>
  <add-or-update pageType="update"></add-or-update>
</template>

<script>
import addOrUpdate from "./components/addOrUpdate.vue";
export default {
  name: "updateAutoStowage",
  components: { addOrUpdate }
};
</script>

<style></style>
